/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'split': {
    width: 24,
    height: 24,
    viewBox: '-8 -8 40 40',
    data: '<g><g stroke-opacity="1"><path pid="0" d="M.41 11.543l9.14-.012c3.583-.005 4.26-6.044 7.92-6.044l6.025-.018-1.984-2.982" _fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-dasharray="none" stroke-opacity="1" paint-order="normal"/><path pid="1" d="M23.495 5.469l-2.009 3.068" _fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-dasharray="none" stroke-opacity="1"/></g><g transform="matrix(1 0 0 -1 0 23.087)" stroke-opacity="1"><path pid="2" d="M.41 11.543l9.14-.012c3.583-.005 4.26-6.044 7.92-6.044l6.025-.018-1.984-2.982" _fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-dasharray="none" stroke-opacity="1" paint-order="normal"/><path pid="3" d="M23.495 5.469l-2.009 3.068" _fill="none" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-dasharray="none" stroke-opacity="1"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/split.js